import { FormValidationRule } from "../types";
import {
    validROISortCodes,
    validNISortCodes,
    validGBSortCodes,
} from "../controls/sort-code-v2/valid-sort-codes";

const isValidSortCode = (sortCode: string, jurisdiction: { ni: boolean, roi: boolean, gb: boolean}) => {
    const validateRoi = jurisdiction.roi? true : false;
    const validateNi = jurisdiction.ni? true : false;
    const validateGb = jurisdiction.gb? true : false;

    const isValidRoi = validateRoi ? validROISortCodes.includes(sortCode) : false;
    const isValidNi = validateNi ? validNISortCodes.includes(sortCode) : false;
    const isValidGb = validateGb ? validGBSortCodes.includes(sortCode) : false;

    if (!validateRoi && !validateNi && !validateGb) {
        return true;
    } else {
        return isValidRoi || isValidNi || isValidGb;
    }
};

const getErrorMessage = (jurisdiction: { ni: boolean, roi: boolean, gb: boolean}) => {
    let jurisdictionLabel = "";
    const jurisdictionLabelArray = [];

    if (jurisdiction && jurisdiction.roi) {
        jurisdictionLabelArray.push("the Republic of Ireland");
    }
    if (jurisdiction && jurisdiction.ni) {
        jurisdictionLabelArray.push("Northern Ireland");
    }
    if (jurisdiction && jurisdiction.gb) {
        jurisdictionLabelArray.push("Great Britain");
    }

    jurisdictionLabel = jurisdictionLabelArray.join(" or ");

    return `We can only accept valid sort codes from ${jurisdictionLabel}. Please check the sort code you have entered and try again.`;
};

const sortCodeV2: FormValidationRule = (c, v) => {
    let valid = true;
    let invalidSortCodeMessage = "";
    
    if (c.type === "sort_code_v2" && v && v.length) {
        const value = v.replace(/-/g, "");
        if (value.length === 4 || value.length !== 6) {
            valid = false;
            invalidSortCodeMessage = "Please use two digits on each input box.";
        } else if (!isValidSortCode(value, c.jurisdiction)) {
            valid = false;
            invalidSortCodeMessage =
                c.errorMessage || getErrorMessage(c.jurisdiction);
        }
    }
    return [valid, invalidSortCodeMessage];
};

export default sortCodeV2;
